import React from 'react'
import { useSelector } from "react-redux";

const PageCounter = () => {
  const visits = useSelector(state => state.visits) || null

  if(!visits || !visits.display) {
    return null;
  }

  return (
    <>
      <span className="icon-visited color-grey font-size-xs margin-right-xxs"></span>
      {visits.as_string}
    </>
  );
}

export default PageCounter
